<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  document.addEventListener("mouseover", function(event) {
  let hoveredElement = event.target;

  if (hoveredElement.matches(".product-item > .card a")) {
    let productItem = hoveredElement.closest(".product-item");
    let productLinks = productItem.querySelectorAll("a");

    productLinks.forEach(function(link) {
      let url = new URL(link.href);
      url.search = ""; // Remove query string
      link.href = url.toString(); // Update the link's href attribute
    });
  }
});


// document.addEventListener("mouseover", function(event) {
//   const hoveredElement = event.target;

//   if (hoveredElement.matches("a.card-title")) {
//     let url = new URL(hoveredElement.href); // Only uses hoveredElement's href
//     url.search = ""; // Remove query string
//     hoveredElement.href = url.toString(); // Update the hovered link's href attribute
//   }
// });